// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimeline-Line_cls1__7Vgq6","cls2":"VeloTimeline-Line_cls2__QCF5i VeloTimeline-Line_cls1__7Vgq6"};